// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { lazy } from "react";
const bankAccountView = lazy(() => import("./bank-account-view/bankAccountView"));
const changeRequestsView = lazy(() => import("./change-request-view/changeRequestView"));
const reportView = lazy(() => import("./reporting-view/reportingView"));
const userGuideView = lazy(() => import("./user-guide-view/userGuideView"));
const employeeOperationsView = lazy(() => import("./employee-operations-view/employeeOperationsView"));
const adminView = lazy(() => import("./admin-view/adminView"));

export const View = {
  bankAccountView,
  changeRequestsView,
  reportView,
  userGuideView,
  employeeOperationsView,
  adminView
};
